import styled, { css } from 'styled-components';
import { isMobileStyleMixin } from '@amzn/storm-ui';

export const UtilityNavContainer = styled.div`
  display: flex;
  align-items: center;
  margin-inline-start: auto;
  padding: ${({ theme }) => theme.spacing.small};
  ${isMobileStyleMixin(css`
    padding: 0;
  `)}
`;

export const ExternalSwitchWrapper = styled.span`
  display: inline-flex;
  padding-right: ${({ theme }) => theme.spacing.medium};

  & label {
    color: ${({ theme }) => theme.header.contextBar.foreground};
  }
`;

export const ExternalToggleTriggerWrapper = styled.span`
  padding-top: 10px;
`;
